// 同時適用於 route.params（string | string[]）與 route.query（string | null 或它的陣列）
export function routeParamString(param: string | (string | null)[] | null | undefined): string {
    if (Array.isArray(param)) return param[0] ?? ""
    return param ?? ""
}

export function routeNameString(name: string | symbol | null | undefined): string {
    return typeof name === "string" ? name : ""
}

export function tabPaneNameToRouteName(name: string | number | undefined): string | undefined {
    return name === undefined ? undefined : String(name)
}

export function routeParamStringArray(param: string | (string | null)[] | null | undefined): string[] {
    if (Array.isArray(param)) return param.filter((item): item is string => item !== null)
    return param ? [param] : []
}
